<template>
  <div id="progress-bar" class="ma-auto">
    <v-row class="my-16">
      <v-col
        v-for="content in stepContents"
        :key="content.step"
        class="pa-0 position-relative"
        align-self="center"
      >
        <div class="step">
          <v-btn
            :id="`step-${content.step}-step`"
            :title="content.title"
            @click="setStep(content.step)"
          >
            <span class="sr-only">{{ content.title }}</span>
            <!-- <img
              :src="require('@/assets/images/carbon/tree_and_carbon_icon.svg')"
              :alt="content.title"
              :title="content.title"
            /> -->
          </v-btn>
          <div class="step-note">{{ content.note }}</div>
        </div>
        <div v-if="content.step !== 1" class="position-relative">
          <div class="bar"></div>
          <div :id="`step-${content.step}-bar`" class="bar-in"></div>
        </div>
      </v-col>
      <v-col class="pa-0 position-relative" align-self="center"></v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      curStep: 1,
      stepContents: [
        { step: 1, title: "樹木與二氧化碳", note: "樹木與二氧化碳" },
        { step: 2, title: "光合作用與減碳", note: "光合作用與減碳" },
        { step: 3, title: "森林碳匯", note: "森林碳匯" },
        { step: 4, title: "校園樹木", note: "校園樹木" },
        { step: 5, title: "碳匯可以計算嗎", note: "碳匯可以計算嗎" }
      ]
    };
  },
  // watch: {
  //   step() {
  //     this.curStep = this.step
  //     // this.setStep(this.step)
  //   }
  // },
  mounted() {
    this.setStep(this.step);
    window.onresize = () => {
      this.calculatePositionWhenSmallScreen(this.curStep);
    };
  },
  methods: {
    calculatePositionWhenSmallScreen(curStep) {
      const cw = document.body.offsetWidth;
      const p = document.getElementById("progress-bar");
      if (cw <= 600 && p.style !== null) {
        p.style.left = "calc((50vw - 1rem + " + -166 * curStep + "px))";
      } else {
        p.style.left = null;
      }
    },
    setStep(step) {
      // eslint-disable-next-line no-unused-vars
      let delay = step - this.curStep;

      const stepC = document.getElementsByTagName("button");
      for (let i = 0; i < stepC.length; i++) {
        stepC[i].classList.remove("is-active");
        stepC[i].classList.remove("is-passed");
      }
      const barC = document.getElementsByClassName("bar-in");
      for (let i = 0; i < barC.length; i++) {
        barC[i].classList.remove("is-passed");
        barC[i].classList.remove("is-passing");
      }

      this.calculatePositionWhenSmallScreen(step);

      // // document.getElementById('step-' + step + '-step').style.transitionDelay =
      // //   delay + 's'
      // // setTimeout(() => {
      document
        .getElementById("step-" + step + "-step")
        .classList.add("is-active");
      // // }, (delay - 0.5) * 1000)
      if (step > 1) {
        document
          .getElementById("step-" + step + "-bar")
          .classList.add("is-passing");
      }

      switch (step) {
        case 6:
          delay = this.delayFunc(6, delay);
        // eslint-disable-next-line no-fallthrough
        case 5:
          delay = this.delayFunc(5, delay);
        // eslint-disable-next-line no-fallthrough
        case 4:
          delay = this.delayFunc(4, delay);
        // eslint-disable-next-line no-fallthrough
        case 3:
          delay = this.delayFunc(3, delay);
        // eslint-disable-next-line no-fallthrough
        case 2:
          delay = this.delayFunc(2, delay);

        // eslint-disable-next-line no-fallthrough
        case 1:
          document.getElementById("step-1-step").classList.add("is-passed");
        // document.getElementById('Step1_bar').classList.add('is-active')
      }
      this.curStep = step;
      this.$emit("getCurStep", step);
    },
    delayFunc(step, delay) {
      const barId = `step-${step}-bar`;
      const stepId = `step-${step}-step`;
      delay = delay > 0 ? delay - 1 : 0;
      document.getElementById(barId).classList.add("is-passed");
      document.getElementById(barId).style.animationDelay = delay + "s";
      document.getElementById(barId).style.transitionDelay = delay + "s";
      if (delay !== 0) {
        document.getElementById(stepId).classList.add("is-passed");
        // setTimeout(() => {
        //   document.getElementById(stepId).classList.add("is-passed");
        // }, delay * 1000 + 500);
      } else {
        document.getElementById(stepId).classList.add("is-passed");
      }
      return delay;
    }
  }
};
</script>

<style lang="scss" scoped>
.step {
  text-align: center;
  font-weight: bolder;
  color: rgb(0, 0, 0);
  // color: rgba(255, 255, 255, 1);
  // padding-top: 0rem;
  // height: 6rem;

  // background-color: #e8bc79;
  // background-image: url("~@/assets/images/Front/Game/step-.svg");
  background-repeat: no-repeat;
  background-position: center 45%;
  background-size: 30%;
  position: absolute;
  right: calc(-3.75rem);
  top: calc(-1.25rem);
  z-index: 5;

  button {
    background-color: #e8bc79 !important;
    display: inline-block;
    font-weight: bolder;
    min-width: 2.5rem !important;
    width: 2.5rem !important;
    height: 2.5rem !important;
    padding: 0 !important;
    border-radius: 50%;
    color: transparent;
    font-size: 0.1rem !important;
  }

  &-note {
    width: 8rem;
    margin-top: 2rem;
    @media all and (max-width: 600px) {
      width: 6.5rem;
    }
  }
}

@for $i from 1 through 6 {
  #step-#{$i}-step {
    &.is-passed {
      background-color: #e8bc79;
      color: transparent;
      // background-image: url("@/assets/images/carbon/reduce_carbon_icon.svg");
      background-repeat: no-repeat;
      background-position: center 45%;
      background-size: 30%;
    }
    &.is-active {
      background-color: #e8bc79;
      color: rgb(0, 0, 0);
      background-image: url("~@/assets/images/carbon/step-"+$i+".svg");
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 70%;
      transition: all 0.35s;
      transform-style: preserve-3d;
      transform: scale(2);
    }
  }
  #step-#{$i}-bar {
    &.is-passed {
      //background-color: #c0e9ec;
      color: rgba(255, 255, 255, 1);
      background-color: #e8bc79;
      // animation: nextStep 0s;
      animation-fill-mode: forwards;
    }
    &.is-passing {
      //background-color: #c0e9ec;
      color: rgba(255, 255, 255, 1);
      background: #e8bc79;
      // animation: nextStep 1s;
      animation-fill-mode: forwards;
    }
  }
}

.bar-in {
  width: 0;
  position: relative;
  z-index: 1;
  transition: all 0.3s;
  height: 0.25rem;
  background-color: #e8bc79;
}
.bar {
  position: absolute;
  background-color: #e8bc79;
  width: 100%;
  height: 0.25rem;
  transition: all 0.3s;
  z-index: 1;
}

// .bar::after {
//   width: 100%;
//   display: block;
//   content: '';
//   z-index: 5;
//   position: absolute;
//   transition: all 0.6s;
//   height: 0.25rem;
//   background-color: red;
// }
@keyframes nextStep {
  0% {
    background: white;
    width: 0%;
  }
  100% {
    width: 100%;
    background: #e8bc79;
  }
}
#progress-bar {
  // right: 0;
  // left: 0;
  // position: absolute;
  // width: calc(100vw - 6rem);
  // height: 20px;
  margin: auto;
  // transform: translateX(calc((50vw - 3rem) / 16));
}
@media all and (max-width: 830px) {
  #progress-bar {
    margin: auto;
    // position: absolute;
    // width: calc(100vw - 4rem);
    // left: calc((100vw - 825px) / 2);
  }
}
@media all and (max-width: 600px) {
  #progress-bar {
    position: absolute;
    width: 1000px;
    // left: calc((100vw - 825px) / 2);
  }
}

.position-relative {
  position: relative;
}

.position-absolute {
  position: absolute;
}
</style>
